(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bundle-builder-dual"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('bb-dual-bundle')) {
  class BBDualBundle extends HTMLElement {
    connectedCallback() {
      if (this.events) return;
      this.events = new AbortController();
      const signal = this.events.signal;
      this.selectors = Array.from(this.querySelectorAll('[data-product-selector]'));
      this.addToCartButton = this.querySelector('[data-add-to-cart]');
      this.addToCartButtonText = this.querySelector('[data-add-to-cart-text]');
      this.selectionText = this.querySelector('[data-selection-text]');
      this.errorMessage = this.querySelector('[data-error-message]');
      this.priceDisplay = this.querySelector('[data-bundle-price]');
      this.comparePriceDisplay = this.querySelector('[data-compare-price]');
      this.compareWrapper = this.querySelector('[data-compare-wrapper]');
      this.bundleDescription = this.querySelector('[data-bundle-description]');
      this.bundleDescriptionShell = this.querySelector('[data-bundle-description-shell]');
      this.defaultDescription = this.querySelector('[data-default-bundle-description-template]');
      this.productDescriptions = Array.from(this.querySelectorAll('[data-product-description-template]'));
      this.desktopThumbnails = this.querySelectorAll('[data-thumbnail-group="desktop"]');
      this.mobileThumbnails = this.querySelectorAll('[data-thumbnail-group="mobile"]');
      this.mainImage = this.querySelector('[data-main-image]');
      this.mainImageWrap = this.querySelector('[data-main-image-wrap]');
      this.galleryViewport = this.querySelector('[data-gallery-viewport]');
      this.galleryItems = this.querySelectorAll('.bb-dual__gallery-desktop .product-gallery-item');
      this.galleryNavigation = this.querySelector('[data-gallery-nav]');
      this.mobileThumbsWrap = this.querySelector('[data-mobile-thumbs-wrap]');
      this.mobileThumbsHolder = this.querySelector('[data-mobile-thumbs-holder]');
      this.selectors.forEach(input => input.addEventListener('change', () => this.updateSelection(input), {signal}));
      this.addToCartButton.addEventListener('click', () => this.addSet(), {signal});
      this.desktopThumbnails.forEach(button => button.addEventListener('click', () => this.handleDesktopThumbnailClick({currentTarget:button}), {signal}));
      this.mobileThumbnails.forEach(button => button.addEventListener('click', () => this.handleMobileThumbnailClick({currentTarget:button}), {signal}));
      this.addEventListener('shopify:block:select', event => {
        const blockId = event.detail && event.detail.blockId;
        const buttons = this.isMobileView() ? this.mobileThumbnails : this.desktopThumbnails;
        const button = Array.from(buttons).find(item => item.dataset.galleryBlockId === blockId);
        if (button) button.click();
      }, {signal});
      this.addEventListener('keydown', event => {
        if (event.key === 'Escape') {
          const details = this.querySelector('.pdp-shipping-promise__info-wrap[open]');
          if (details) { details.open = false; details.querySelector('summary').focus(); }
        }
      }, {signal});
      this.lastMobile = this.isMobileView();
      this.refreshGallery = () => {
        const mobile = this.isMobileView();
        if (mobile !== this.lastMobile) {
          const active = Array.from(mobile ? this.mobileThumbnails : this.desktopThumbnails).find(button => button.getAttribute('aria-pressed') === 'true');
          this.lastMobile = mobile;
          if (active) {
            if (mobile) this.handleMobileThumbnailClick({currentTarget:active,preventScroll:true});
            else this.handleDesktopThumbnailClick({currentTarget:active});
          }
        }
        this.syncDesktopActiveThumbnail(); this.updateDesktopNavState(); this.updateMobileThumbCue();
      };
      this.queueGalleryUpdate = () => {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => { this.frame = null; this.refreshGallery(); });
      };
      if (this.galleryViewport) this.galleryViewport.addEventListener('scroll', this.queueGalleryUpdate, {passive:true,signal});
      if (this.mobileThumbsHolder) this.mobileThumbsHolder.addEventListener('scroll', this.queueGalleryUpdate, {passive:true,signal});
      window.addEventListener('resize', this.queueGalleryUpdate, {passive:true,signal});
      this.updateSelection();
      this.refreshGallery();
    }

    disconnectedCallback() {
      if (this.events) this.events.abort();
      this.events = null;
      if (this.frame) cancelAnimationFrame(this.frame);
      this.frame = null;
      // Do not abort a cart POST on editor unload: it may already have mutated the cart.
    }

    getSelectedVariants() {
      return ['1','2'].map(group => this.selectors.find(input => input.dataset.group === group && input.checked && !input.disabled))
        .filter(Boolean).map(input => ({id:input.value,price:Number(input.dataset.price)||0,label:input.dataset.productLabel,notes:input.dataset.description,group:input.dataset.group}));
    }

    updateSelection(changedInput) {
      const selected = this.getSelectedVariants();
      this.querySelectorAll('[data-group-description]').forEach(el => {
        const choice = selected.find(item => item.group === el.dataset.groupDescription);
        el.textContent = choice ? choice.notes : '';
      });
      this.selectionText.textContent = selected.length ? selected.map(item => item.label).join(' + ') : this.dataset.selectionPrompt;
      this.updatePriceDisplay(selected);
      if (changedInput) this.updateBundleDescription(changedInput);
      // Match the tiered builder: validate on click; disable only during an add. -Jenny 11/3/26
      this.addToCartButton.disabled = Boolean(this.busy);
      this.errorMessage.hidden = true;
    }

    updateBundleDescription(input) {
      // Clone only Shopify-rendered rich-text templates; never inject API/error HTML. -Jenny 11/3/26
      const productTemplate = this.productDescriptions.find(template => template.dataset.descriptionBlock === input.dataset.descriptionBlock);
      const template = input.checked && productTemplate && productTemplate.content.textContent.trim()
        ? productTemplate : this.defaultDescription;
      this.bundleDescription.replaceChildren(template.content.cloneNode(true));
      this.bundleDescriptionShell.hidden = !template.content.textContent.trim();
    }

    updatePriceDisplay(selected) {
      if (!this.priceDisplay) return;
      const fullPrice = selected.reduce((sum, item) => sum + item.price, 0);
      const secondItem = selected.find(item => item.group === '2');
      const percent = Math.min(100, Math.max(0, Number(this.dataset.secondGroupDiscount) || 0));
      // Only a complete pair qualifies in this preview. Shopify enforces the actual automatic discount.
      const savings = selected.length === 2 ? Math.round(secondItem.price * percent / 100) : 0;
      this.priceDisplay.textContent = this.formatMoney(fullPrice - savings);
      this.comparePriceDisplay.textContent = savings > 0 ? this.formatMoney(fullPrice) : '';
      this.compareWrapper.hidden = savings <= 0;
    }

    formatMoney(cents) {
      return new Intl.NumberFormat(document.documentElement.lang || undefined, {style:'currency',currency:this.dataset.currencyCode || 'USD'}).format(cents/100);
    }

    showError(message) {
      this.errorMessage.textContent = message;
      this.errorMessage.hidden = false;
      this.errorMessage.focus();
    }

    async addSet() {
      if (this.busy) return;
      if (BBDualBundle.cartPending) { this.showError(this.dataset.cartBusyText); return; }
      const selected = this.getSelectedVariants();
      if (selected.length !== 2) { this.showError(this.dataset.selectionPrompt); return; }
      this.busy = true;
      BBDualBundle.cartPending = true;
      this.errorMessage.hidden = true;
      this.querySelectorAll('[data-choice-group]').forEach(group => { group.disabled = true; });
      this.addToCartButton.disabled = true;
      this.addToCartButton.setAttribute('aria-busy','true');
      this.addToCartButtonText.textContent = this.dataset.addingText;
      const request = new AbortController();
      const timeout = setTimeout(() => request.abort(), 20000);
      try {
        // Same Shopify multi-item add used by the existing builder. Recharge owns drawer updates. -Jenny 11/3/26
        const items = [];
        selected.forEach(item => {
          const existing = items.find(line => line.id === item.id);
          if (existing) existing.quantity += 1; else items.push({id:item.id,quantity:1});
        });
        const response = await fetch(this.dataset.addUrl, {
          method:'POST', headers:{'Content-Type':'application/json'},
          body:JSON.stringify({items}), signal:request.signal
        });
        const result = await response.json();
        if (!response.ok || Number(result.status) >= 400) {
          // Rejected multi-item requests can still need cart review; never auto-retry or remove items.
          this.showError(this.dataset.errorText + (typeof result.description === 'string' ? ' ' + result.description : ''));
          return;
        }
        const added = Array.isArray(result.items) ? result.items : [];
        if (!items.every(item => added.some(line => String(line.variant_id || line.id) === item.id && Number(line.quantity) >= item.quantity))) {
          this.showError(this.dataset.uncertainText);
          return;
        }
        this.selectionText.textContent = this.dataset.successText;
        // Preserve the working app-managed cart: no second drawer, guessed events, redirect or cart DOM replacement.
      } catch (_) {
        this.showError(this.dataset.uncertainText);
      } finally {
        clearTimeout(timeout);
        BBDualBundle.cartPending = false;
        this.busy = false;
        this.querySelectorAll('[data-choice-group]').forEach(group => { group.disabled = false; });
        this.addToCartButton.removeAttribute('aria-busy');
        this.addToCartButtonText.textContent = this.dataset.buttonLabel;
        this.addToCartButton.disabled = false;
      }
    }
      isMobileView() {
        return window.matchMedia('(max-width: 1024px)').matches;
      }

      setActiveThumbnail(activeIndex) {
        this.desktopThumbnails.forEach((thumb, index) => {
          thumb.classList.toggle('active', index === activeIndex);
          thumb.setAttribute('aria-pressed', index === activeIndex ? 'true' : 'false');
        });

        this.mobileThumbnails.forEach((thumb, index) => {
          thumb.classList.toggle('active', index === activeIndex);
          thumb.setAttribute('aria-pressed', index === activeIndex ? 'true' : 'false');
        });
      }

      syncDesktopActiveThumbnail() {
        if (!this.galleryItems.length || this.isMobileView()) return;

        const reversedGallerySlides = Array.from(this.galleryItems).reverse();

        for (const slide of reversedGallerySlides) {
          const rect = slide.getBoundingClientRect();
          const viewportRect = this.galleryViewport.getBoundingClientRect();
          const slideTop = rect.top - viewportRect.top;

          if (slideTop < viewportRect.height / 2 && slideTop > -viewportRect.height / 2) {
            const index = parseInt(slide.dataset.index, 10) || 0;
            this.setActiveThumbnail(index);
            break;
          }
        }
      }

      updateDesktopNavState() {
        if (!this.galleryViewport || !this.galleryNavigation || this.isMobileView()) return;

        const scrollTop = this.galleryViewport.scrollTop;
        const maxScroll = this.galleryViewport.scrollHeight - this.galleryViewport.clientHeight;

        if (scrollTop <= 1) {
          this.galleryNavigation.classList.add('scroll');
          this.galleryNavigation.classList.add('scroll-up');
        } else if (scrollTop >= maxScroll - 1) {
          this.galleryNavigation.classList.add('scroll');
          this.galleryNavigation.classList.remove('scroll-up');
        } else {
          this.galleryNavigation.classList.remove('scroll');
          this.galleryNavigation.classList.remove('scroll-up');
        }
      }

      updateMobileThumbCue() {
        if (!this.mobileThumbsHolder || !this.mobileThumbsWrap) return;

        const maxScroll = this.mobileThumbsHolder.scrollWidth - this.mobileThumbsHolder.clientWidth;
        const scrollLeft = this.mobileThumbsHolder.scrollLeft;

        const canScrollLeft = scrollLeft > 2;
        const canScrollRight = scrollLeft < maxScroll - 2;

        this.mobileThumbsWrap.setAttribute('data-can-scroll-left', canScrollLeft ? 'true' : 'false');
        this.mobileThumbsWrap.setAttribute('data-can-scroll-right', canScrollRight ? 'true' : 'false');
      }

      handleDesktopThumbnailClick(e) {
        const clickedThumbnail = e.currentTarget;
        const index = parseInt(clickedThumbnail.dataset.index, 10);

        this.setActiveThumbnail(index);

        const targetItem = this.querySelector('.bb-dual__gallery-desktop .product-gallery-item[data-index="' + index + '"]');
        if (targetItem && this.galleryViewport) {
          this.galleryViewport.scrollTo({
            top: targetItem.offsetTop,
            behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
          });
        }
      }

      handleMobileThumbnailClick(e) {
        const clickedThumbnail = e.currentTarget;
        const index = parseInt(clickedThumbnail.dataset.index, 10);
        const fullSrc = clickedThumbnail.dataset.fullSrc;
        const fullAlt = clickedThumbnail.dataset.fullAlt || '';
        const fullRatio = parseFloat(clickedThumbnail.dataset.fullRatio || '1') || 1;
        const fullWidth = parseInt(clickedThumbnail.dataset.fullWidth || '0', 10);
        const fullHeight = parseInt(clickedThumbnail.dataset.fullHeight || '0', 10);

        this.setActiveThumbnail(index);

        if (!this.mainImage && this.mainImageWrap && fullSrc) {
          const placeholder = this.mainImageWrap.querySelector('[data-main-image-placeholder]');
          if (placeholder) {
            placeholder.remove();
          }

          this.mainImage = document.createElement('img');
          this.mainImage.setAttribute('data-main-image', '');
          this.mainImage.loading = 'eager';
          this.mainImage.fetchPriority = 'high';
          this.mainImage.style.position = 'absolute';
          this.mainImage.style.inset = '0';
          this.mainImage.style.width = '100%';
          this.mainImage.style.height = '100%';
          this.mainImage.style.objectFit = 'cover';
          this.mainImage.style.objectPosition = 'center';
          this.mainImage.style.display = 'block';

          this.mainImageWrap.appendChild(this.mainImage);
        }

        if (this.mainImage && fullSrc) {
          this.mainImage.src = fullSrc;
          this.mainImage.srcset = clickedThumbnail.dataset.fullSrcset || "";
          this.mainImage.alt = fullAlt;

          if (fullWidth > 0) {
            this.mainImage.width = fullWidth;
          }

          if (fullHeight > 0) {
            this.mainImage.height = fullHeight;
          }
        }

        if (this.mainImageWrap && fullRatio > 0) {
          this.mainImageWrap.style.paddingTop = (100 / fullRatio) + '%';
        }

        if (!e.preventScroll) clickedThumbnail.scrollIntoView({
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
          block: 'nearest',
          inline: 'center'
        });

        window.requestAnimationFrame(() => {
          this.updateMobileThumbCue();
        });
      }


  }
  customElements.define('bb-dual-bundle', BBDualBundle);
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["category-navigation"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const section = document.querySelector('[data-section-id="{{ section.id }}"]');
  const container = section?.querySelector('.category-nav__container');
  if (!container) return;

  
  container.addEventListener('keydown', function(e) {
    if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
      e.preventDefault();
      const scrollAmount = e.key === 'ArrowRight' ? 100 : -100;
      container.scrollBy({
        left: scrollAmount,
        behavior: 'smooth'
      });
    }
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();
      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);
        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const innerHTML = new DOMParser()
                .parseFromString(text, 'text/html')
                .querySelector('product-recommendations');
            if ( innerHTML && innerHTML.querySelectorAll('.product-item').length > 0 ) {
              this.innerHTML = innerHTML.innerHTML;
              window.preloadImages(this);
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();
      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);
        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const innerHTML = new DOMParser()
                .parseFromString(text, 'text/html')
                .querySelector('product-recommendations');
            if ( innerHTML && innerHTML.querySelectorAll('.product-item').length > 0 ) {
              this.innerHTML = innerHTML.innerHTML;
              window.preloadImages(this);
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["static-pdp-showcase"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const section = document.querySelector('[data-section-id="{{ section.id }}"]');
  const grid = section?.querySelector('.product-showcase__grid');
  if (!grid) return;

  
  // Keyboard navigation for mobile scroll
  grid.addEventListener('keydown', function(e) {
    if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
      e.preventDefault();
      const scrollAmount = e.key === 'ArrowRight' ? grid.clientWidth * 0.85 : -(grid.clientWidth * 0.85);
      grid.scrollBy({
        left: scrollAmount,
        behavior: 'smooth'
      });
    }
  });

  // Ensure grid items are focusable
  const items = grid.querySelectorAll('.product-showcase__link');
  items.forEach(item => {
    item.setAttribute('tabindex', '0');
  });
});

  } catch(e) { console.error(e); }
})();
})();
